module.exports = __webpack_public_path__ + "img/discord-logo.944d5204969ad96ede6fdc575d86210f.png";